import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/GetAccommodationAvailabilities'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class GetAccommodationAvailabilitiesStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "GetAccommodationAvailabilitiesStore",
			variables: true,
		})
	}
}

export async function load_GetAccommodationAvailabilities(params) {
  await initClient()

	const store = new GetAccommodationAvailabilitiesStore()

	await store.fetch(params)

	return {
		GetAccommodationAvailabilities: store,
	}
}
